import {
  DevinirTransferInKindState,
  DrivewealthAccountLiquidationStatus,
  DrivewealthAccountSummary
} from "@/shared/types";

import * as storeHelper from "@/shared/storeHelper";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: DevinirTransferInKindState = {
  nonCompliantMessageAcknowledged: false
};


export const useDevinirTransferInKindStore = defineStore("devinirTransferInKind", {
  persist: {
    storage: localStorage,
    paths: storeHelper.getStoragePaths("devinirTransferInKind"),
  },
  getters: {
    nonCompliantDevinirInvestmentAccounts (): DrivewealthAccountSummary[] {
      const drivewealthStore = useDrivewealthStore();

      const migratedAccounts = _.filter(drivewealthStore.accountClaims, x => {
        return x.isClaimed === false && x.isRepointedAccount === false;
      });

      let nonCompliantAccounts = [];

      migratedAccounts.forEach(x => {
        const accountSummary = drivewealthStore.accountSummaryById(x.drivewealthApiAccountId);

        if (accountSummary &&
          accountSummary.equityValue > 0 &&
          (accountSummary.liquidationStatus === DrivewealthAccountLiquidationStatus.NotStarted ||
            accountSummary.liquidationStatus === DrivewealthAccountLiquidationStatus.Failed)) {
              nonCompliantAccounts = [...nonCompliantAccounts, accountSummary];
        }
      });

      return nonCompliantAccounts;
    },
    nonCompliantDevinirInvestmentAccountId (): number {
      if (this.nonCompliantDevinirInvestmentAccounts.length) {
        const firstNonCompliantAccount: DrivewealthAccountSummary = _.head(this.nonCompliantDevinirInvestmentAccounts);

        return firstNonCompliantAccount.drivewealthAccountId;
      }

      return null;
    },
    hasNonCompliantDevinirInvestmentAccounts (): boolean {
      return !!this.nonCompliantDevinirInvestmentAccounts.length;
    }
  },
  state: (): DevinirTransferInKindState => (_.cloneDeep(initialState)),
  actions: {
    setMessageAcknowledged (acknowledged: boolean) {
      this.nonCompliantMessageAcknowledged = acknowledged;
    },
  }
});